import { Component, inject, Signal } from '@angular/core';
import { Dialog } from '../dialog';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { DialogComponent } from '../dialog/dialog.component';
import {
  IOperatorMappingForm,
  OperatorMappingFactory,
} from '../../../factory/operator-mapping/operator-mapping-factory.service';
import { TextInputComponent } from '../../data-input/form-inputs/text-input/text-input.component';
import { DropDownComponent } from '../../data-input/form-inputs/drop-down/drop-down.component';
import { ButtonComponent } from '../../feedback/button/button.component';
import { SortsStore } from '../../../services/api/sorts/sorts-store.service';
import { IHusstSortGroup, ITariffSort } from '@web/dtos';
import { SortGroupsStore } from '../../../services/api/sort-groups/sort-groups-store.service';

@Component({
  selector: 'aw-edit-operator-mapping-dialog',
  imports: [
    DialogComponent,
    ReactiveFormsModule,
    TextInputComponent,
    DropDownComponent,
    ButtonComponent,
  ],
  templateUrl: './edit-operator-mapping-dialog.component.html',
})
export class EditOperatorMappingDialog extends Dialog<{
  operatorMapping: FormGroup<IOperatorMappingForm>;
}> {
  private readonly formFactory: OperatorMappingFactory = inject(
    OperatorMappingFactory
  );
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  protected readonly sortsStore: SortsStore = inject(SortsStore);
  protected readonly sorts: Signal<ITariffSort[]> = this.sortsStore.sorts;
  protected readonly sortsLoading: Signal<boolean> = this.sortsStore.isLoading;

  protected readonly sortGroupsStore: SortGroupsStore = inject(SortGroupsStore);
  protected readonly sortGroups: Signal<IHusstSortGroup[]> =
    this.sortGroupsStore.sortGroups;
  protected readonly sortGroupsLoading: Signal<boolean> =
    this.sortGroupsStore.isLoading;

  constructor() {
    super();
    [
      this.data.operatorMapping.controls.onDemandSortExternalRef,
      this.data.operatorMapping.controls.comfortSortExternalRef,
      this.data.operatorMapping.controls.publicTransportProductGroup,
    ].forEach(control => {
      control.valueChanges.subscribe(value => {
        if (value === '') control.setValue(null, { emitEvent: false });
      });
    });
  }

  addDropDownOption(): void {
    this.data.operatorMapping.controls.dropDownOptions.push(
      this.formFactory.buildOptionForm()
    );
  }

  removeDropDownOption(index: number): void {
    this.data.operatorMapping.controls.dropDownOptions.removeAt(index);
    this.data.operatorMapping.controls.dropDownOptions.updateValueAndValidity();
  }
}
